import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-pdf-upload',
  templateUrl: './pdf-upload.component.html',
  styleUrls: ['./pdf-upload.component.scss'],
  standalone: false
})
export class PdfUploadComponent implements OnInit {
  @Input() accessoryUuid?: string;
  @Input() pictureUuid?: string;
  @Output() uploadComplete = new EventEmitter<{ accessoryUuid: string }>();
  file?: File;
  isUploading = false;
  isDragging = false;
  private generatedPictureUuid?: string;


  identifierControl = new FormControl<'AccessoryUUID' | 'PictureUUID' | 'NewUUID'>('AccessoryUUID');

  identifierOptions = this.getIdentifierOptions();

  HOST = environment.pumpDataUrl;
  ADDRESS = 'accessory/pdf';
  pdfUrl!: string;

  constructor(private http: HttpClient) { }

  getIdentifierOptions() {
  const options: Array<{
    label: string;
    key: 'AccessoryUUID' | 'PictureUUID' | 'NewUUID';
    value: 'accessoryUuid' | 'pictureUuid' | 'newPictureUuid';
  }> = [];
 console.log('Getting identifier options', this.accessoryUuid, this.pictureUuid);
  if (!this.accessoryUuid && !this.pictureUuid) {
    return options;
  }

  if (this.accessoryUuid ) {
    options.push({
      label: 'Upload Accessory PDF',
      key: 'AccessoryUUID',
      value: 'accessoryUuid',
    });
  }

  if (this.pictureUuid) {
    if (this.pictureUuid === this.accessoryUuid) {
      options.push({
        label: 'Create Accessory PDF',
        key: 'NewUUID',
        value: 'newPictureUuid',
      });
    } else {
      options.push({
        label: 'Upload Category PDF',
        key: 'PictureUUID',
        value: 'pictureUuid',
      });
    }
  }

  return options;
}


  ngOnInit() {
    if (!this.accessoryUuid && this.pictureUuid) {
      this.identifierControl.setValue('PictureUUID');
    }
    this.identifierOptions = this.getIdentifierOptions();

  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave() {
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;

    const files = event.dataTransfer?.files;
    if (!files || files.length === 0) {
      return;
    }

    const file = files[0];
    if (file.type !== 'application/pdf') {
      return;
    }

    this.file = file;
  }

  upload() {
    const selectedUuid = this.getSelectedUuid();
    if (!this.file || !selectedUuid) {
      return;
    }

    this.isUploading = true;

    const reader = new FileReader();

    reader.onload = () => {
      const base64 = (reader.result as string).split(',')[1];

      this.http
        .post(this.HOST + this.ADDRESS, {
          accessoryUuid: selectedUuid,
          fileBase64: base64,
        })
        .subscribe({
          next: () => {
            this.isUploading = false;
            this.file = undefined;
          },
          error: () => {
            this.isUploading = false;
          },
        });
    };

    reader.readAsDataURL(this.file);
    this.uploadComplete.emit({ accessoryUuid: selectedUuid });
  }

  viewPdf(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    const selectedUuid = this.getSelectedUuid();
    if (!selectedUuid) return;

    this.http
      .get(this.HOST + this.ADDRESS + '/' + selectedUuid, {
        responseType: 'text',
      })
      .subscribe({
        next: (url) => {
          window.open(url, '_blank');
        },
        error: (err) => console.error('Failed to fetch PDF URL', err),
      });
  }

  getSelectedUuid(): string | undefined {
    switch (this.identifierControl.value) {
      case 'AccessoryUUID':
        return this.accessoryUuid;

      case 'PictureUUID':
        return this.pictureUuid;

      case 'NewUUID':
        return this.getOrCreateNewUuid();

      default:
        return undefined;
    }
  }

  selectedUuidByControl(
  control: 'AccessoryUUID' | 'PictureUUID' | 'NewUUID'
): string | undefined {
  switch (control) {
    case 'AccessoryUUID':
      return this.accessoryUuid;

    case 'PictureUUID':
      {
        if( this.pictureUuid !== this.accessoryUuid ) {
        return this.pictureUuid;
        } else {
          return undefined;
        }
      }

    case 'NewUUID':
      {
        if( this.pictureUuid === this.accessoryUuid ) {
        return this.getOrCreateNewUuid();
        } else {
          return undefined;
        }
      }

    default:
      return undefined;
  }
}

  generateNewUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  private getOrCreateNewUuid(): string {
    if (!this.generatedPictureUuid) {
      this.generatedPictureUuid = this.generateNewUUID();
    }
    return this.generatedPictureUuid;
  }

}

